import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function AccessControlSystemsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = "Geçiş Kontrol Sistemleri Kurulumu İstanbul | Kartlı Biyometrik Geçiş";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel geçiş kontrol sistemleri kurulumu. Kartlı, şifreli ve biyometrik geçiş sistemleri ile personel takibi ve güvenlik kontrolü.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel geçiş kontrol sistemleri kurulumu. Kartlı, şifreli ve biyometrik geçiş sistemleri ile personel takibi ve güvenlik kontrolü.';
      document.head.appendChild(meta);
    }

    // Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'geçiş kontrol sistemi, kartlı geçiş, biyometrik geçiş, parmak izi okuyucu, yüz tanıma sistemi, PDKS');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'geçiş kontrol sistemi, kartlı geçiş, biyometrik geçiş, parmak izi okuyucu, yüz tanıma sistemi, PDKS';
      document.head.appendChild(meta);
    }

    // Open Graph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Geçiş Kontrol Sistemleri Kurulumu İstanbul | Kartlı Biyometrik Geçiş');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Geçiş Kontrol Sistemleri Kurulumu İstanbul | Kartlı Biyometrik Geçiş';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fabrika ve sanayi tesisleri için akıllı geçiş kontrol çözümleri. Personel takibi, ziyaretçi yönetimi ve güvenli erişim kontrolü.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fabrika ve sanayi tesisleri için akıllı geçiş kontrol çözümleri. Personel takibi, ziyaretçi yönetimi ve güvenli erişim kontrolü.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/guvenlik-sistemleri/gecis-kontrol-sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/guvenlik-sistemleri/gecis-kontrol-sistemleri';
      document.head.appendChild(meta);
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/guvenlik-sistemleri/gecis-kontrol-sistemleri');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/guvenlik-sistemleri/gecis-kontrol-sistemleri';
      document.head.appendChild(link);
    }

    // Cleanup function
    return () => {
      document.title = 'Fiber Optik Ustası';
    };
  }, []);

  const features = [
    { icon: 'ri-bank-card-line', title: 'Kartlı Geçiş', description: 'RFID ve akıllı kart sistemleri' },
    { icon: 'ri-fingerprint-line', title: 'Parmak İzi', description: 'Biyometrik parmak izi okuyucu' },
    { icon: 'ri-user-smile-line', title: 'Yüz Tanıma', description: 'AI destekli yüz tanıma teknolojisi' },
    { icon: 'ri-time-line', title: 'Zaman Takibi', description: 'Personel giriş-çıkış kayıtları' },
    { icon: 'ri-smartphone-line', title: 'Mobil Erişim', description: 'Akıllı telefon ile geçiş' },
    { icon: 'ri-cloud-line', title: 'Bulut Yönetim', description: 'Uzaktan sistem yönetimi' }
  ];

  const systemTypes = [
    {
      title: 'Kartlı Geçiş Kontrol Sistemleri',
      description: 'RFID, Mifare ve akıllı kart teknolojileri ile güvenli geçiş kontrolü. Kart kayıp durumunda anında iptal edilebilir. Farklı yetki seviyeleri tanımlanabilir.',
      specs: ['RFID/Mifare kartlar', 'Çoklu yetki seviyesi', 'Zaman bazlı erişim', 'Kayıt tutma']
    },
    {
      title: 'Biyometrik Parmak İzi Sistemleri',
      description: 'Parmak izi okuyucu ile yüksek güvenlikli geçiş kontrolü. Kart kaybı veya şifre unutma riski yoktur. Hızlı ve doğru kimlik doğrulama sağlar.',
      specs: ['Optik/kapasitif sensör', '1:N tanıma', 'Sahte parmak algılama', 'Yüksek doğruluk']
    },
    {
      title: 'Yüz Tanıma Sistemleri',
      description: 'Yapay zeka destekli yüz tanıma teknolojisi ile temassız geçiş kontrolü. Maske algılama ve ateş ölçümü özellikleri ile pandemi güvenliği sağlar.',
      specs: ['AI yüz tanıma', 'Temassız geçiş', 'Maske algılama', 'Ateş ölçümü']
    },
    {
      title: 'Şifreli Geçiş Sistemleri',
      description: 'PIN kod ile geçiş kontrolü. Düşük maliyetli ve kolay kullanımlı çözüm. Kart veya biyometrik okuyucu ile kombine edilebilir.',
      specs: ['Tuş takımı', 'Şifre yönetimi', 'Geçici kodlar', 'Acil durum kodu']
    }
  ];

  const faqs = [
    {
      question: 'Geçiş kontrol sistemleri nasıl çalışır?',
      answer: 'Geçiş kontrol sistemleri, yetkili kişilerin belirli alanlara erişimini kontrol eden elektronik güvenlik sistemleridir. Sistem, kart okuyucu, biyometrik okuyucu veya şifre paneli gibi kimlik doğrulama cihazları, kontrol paneli, elektrikli kilit ve yazılımdan oluşur. Kullanıcı kimliğini doğruladığında, kontrol paneli yetki kontrolü yapar ve yetkili ise elektrikli kilidi açar. Tüm giriş-çıkış hareketleri kaydedilir ve raporlanabilir.'
    },
    {
      question: 'Hangi geçiş kontrol sistemini seçmeliyim?',
      answer: 'Sistem seçimi, güvenlik ihtiyacınıza ve bütçenize göre yapılır. Düşük güvenlik gerektiren alanlarda kartlı sistemler yeterlidir. Orta seviye güvenlik için kart + şifre kombinasyonu önerilir. Yüksek güvenlik gerektiren alanlarda biyometrik sistemler (parmak izi veya yüz tanıma) tercih edilir. Fabrika ve sanayi tesislerinde genellikle kartlı sistemler ile biyometrik sistemlerin kombinasyonu kullanılır. Profesyonel keşif sonrası en uygun sistem önerilir.'
    },
    {
      question: 'Geçiş kontrol sistemi kurulumu ne kadar sürer?',
      answer: 'Kurulum süresi, kapı sayısına ve sistem karmaşıklığına bağlıdır. Tek kapı için kurulum 4-6 saat sürer. 5-10 kapılı sistemler 1-2 gün, 20+ kapılı büyük tesisler 3-5 gün gerektirebilir. Kurulum, kart okuyucu montajı, elektrikli kilit takılması, kontrol paneli kurulumu, kablo çekimi ve yazılım yapılandırmasını içerir. Kurulum sonrası personel eğitimi verilir ve sistem testleri yapılır.'
    },
    {
      question: 'Elektrik kesintisinde sistem çalışır mı?',
      answer: 'Evet, geçiş kontrol sistemleri yedek güç kaynağı ile donatılır. Elektrik kesintisinde sistem 8-12 saat boyunca çalışmaya devam eder. Elektrikli kilitler, fail-safe (elektrik kesildiğinde açık kalır) veya fail-secure (elektrik kesildiğinde kilitli kalır) olarak yapılandırılabilir. Güvenlik gereksinimine göre uygun mod seçilir. Acil çıkış kapılarında yangın alarm sistemi ile entegrasyon yapılarak, alarm durumunda otomatik açılma sağlanır.'
    },
    {
      question: 'Geçiş kontrol sistemi personel takibi için kullanılabilir mi?',
      answer: 'Evet, geçiş kontrol sistemleri aynı zamanda personel devam takibi (PDKS) için kullanılır. Her personelin giriş-çıkış saatleri kaydedilir, mesai süreleri hesaplanır ve raporlanır. Geç kalma, erken çıkış ve fazla mesai otomatik olarak tespit edilir. Sistem, bordro yazılımları ile entegre çalışabilir. Fabrika ve sanayi tesislerinde vardiya takibi, ziyaretçi yönetimi ve yemek kartı entegrasyonu da yapılabilir.'
    },
    {
      question: 'Hangi bölgelerde geçiş kontrol sistemleri kurulumu yapıyorsunuz?',
      answer: 'İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Ataşehir, Kadıköy, Ümraniye, Esenyurt, Başakşehir, Pendik, Kartal, Beylikdüzü, Tuzla, Gebze, Dilovası, Çayırova, Kocaeli, Sakarya, Yalova, Bursa, Tekirdağ ve Çorlu bölgelerinde geçiş kontrol sistemleri kurulumu hizmeti veriyoruz. Fabrika, sanayi tesisi, OSB ve kurumsal işletmelere özel çözümler sunuyoruz.'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/5ab9d8ef8fd60ee4c74cec6b3a94ed08.jpg"
            alt="Geçiş Kontrol Sistemleri"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/85 to-slate-950"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-cyan-400 transition-colors cursor-pointer">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/guvenlik-sistemleri" className="hover:text-cyan-400 transition-colors cursor-pointer">Güvenlik Sistemleri</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-cyan-400">Geçiş Kontrol Sistemleri</span>
          </nav>

          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-600/20 border border-cyan-500/30 rounded-full mb-6">
              <i className="ri-door-lock-line text-cyan-400 text-lg"></i>
              <span className="text-cyan-300 text-sm font-medium">Akıllı Geçiş Kontrol</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Geçiş Kontrol Sistemleri Kurulumu
            </h1>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde fabrika, sanayi tesisi ve kurumsal işletmeler için profesyonel geçiş kontrol sistemleri kurulumu. Kartlı, şifreli ve biyometrik geçiş sistemleri ile personel takibi ve güvenlik kontrolü.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp Destek
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <article className="prose prose-invert prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-white mb-6">Geçiş Kontrol Sistemleri Nedir?</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Geçiş kontrol sistemleri, yetkili kişilerin belirli alanlara erişimini kontrol eden ve tüm giriş-çıkış hareketlerini kaydeden elektronik güvenlik sistemleridir. Kart okuyucu, biyometrik okuyucu, şifre paneli gibi kimlik doğrulama cihazları kullanarak, sadece yetkili personelin belirlenen alanlara girmesine izin verir. Sistem, her personel için farklı yetki seviyeleri tanımlar ve giriş-çıkış saatlerini otomatik olarak kaydeder.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Fabrika, sanayi tesisi, ofis ve kurumsal işletmelerde geçiş kontrol sistemleri, hem güvenlik hem de personel yönetimi için kritik öneme sahiptir. İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde profesyonel geçiş kontrol sistemleri kurulumu hizmeti veriyoruz. Kartlı, şifreli, parmak izi ve yüz tanıma sistemleri ile kapsamlı çözümler sunuyoruz.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Geçiş Kontrol Sistemlerinin Özellikleri</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 not-prose">
                {features.map((feature, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300">
                    <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-lg mb-4">
                      <i className={`${feature.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Geçiş Kontrol Sistem Türleri</h2>
              <div className="space-y-6 mb-8 not-prose">
                {systemTypes.map((system, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300">
                    <h3 className="text-2xl font-bold text-white mb-3">{system.title}</h3>
                    <p className="text-gray-300 leading-relaxed mb-4">{system.description}</p>
                    <div className="flex flex-wrap gap-3">
                      {system.specs.map((spec, idx) => (
                        <span key={idx} className="px-3 py-1 bg-cyan-600/20 border border-cyan-500/30 rounded-full text-cyan-300 text-sm">
                          {spec}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Geçiş Kontrol Sistemi Kurulum Süreci</h2>
              <div className="space-y-6 mb-8 not-prose">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-full text-white font-bold">1</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">İhtiyaç Analizi</h3>
                    <p className="text-gray-300">Tesiste keşif yapılır, kontrol edilecek kapılar belirlenir. Personel sayısı, vardiya düzeni ve güvenlik gereksinimleri analiz edilir.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-full text-white font-bold">2</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Sistem Tasarımı</h3>
                    <p className="text-gray-300">Uygun okuyucu türleri seçilir, elektrikli kilit tipleri belirlenir. Yetki seviyeleri ve zaman dilimleri planlanır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-full text-white font-bold">3</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Donanım Kurulumu</h3>
                    <p className="text-gray-300">Kart okuyucular ve biyometrik cihazlar monte edilir. Elektrikli kilitler takılır, kontrol paneli kurulur, kablolama yapılır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-full text-white font-bold">4</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Yazılım Yapılandırması</h3>
                    <p className="text-gray-300">Geçiş kontrol yazılımı kurulur, personel bilgileri girilir, kartlar veya biyometrik veriler tanımlanır. Yetki matrisi oluşturulur.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-full text-white font-bold">5</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Test ve Eğitim</h3>
                    <p className="text-gray-300">Tüm kapılar test edilir, yetki kontrolleri doğrulanır. Personele sistem kullanımı, kart/biyometrik kayıt ve raporlama hakkında eğitim verilir.</p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Elektrikli Kilit Türleri</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                <strong className="text-white">Elektromanyetik Kilitler:</strong> Güçlü manyetik tutma kuvveti ile kapıyı kilitler. 280 kg'a kadar tutma gücü sağlar. Cam kapılar ve metal kapılar için idealdir. Fail-safe çalışır, elektrik kesildiğinde açılır. Acil çıkış kapılarında tercih edilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-6">
                <strong className="text-white">Elektrikli Mandal Kilitler:</strong> Mekanik kilit mekanizması ile çalışır. Fail-secure veya fail-safe olarak yapılandırılabilir. Ahşap ve metal kapılarda kullanılır. Yüksek güvenlik gerektiren alanlarda tercih edilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                <strong className="text-white">Elektrikli Gömme Kilitler:</strong> Kapı içine gömülü montaj. Estetik görünüm sağlar. Ofis ve idari alanlarda kullanılır. Kartlı otel kilitleri bu kategoridedir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Personel Devam Takibi (PDKS)</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Geçiş kontrol sistemleri, aynı zamanda personel devam takip sistemi (PDKS) olarak kullanılır. Her personelin giriş-çıkış saatleri otomatik olarak kaydedilir ve mesai süreleri hesaplanır. Geç kalma, erken çıkış, fazla mesai ve izin durumları raporlanır. Vardiya takibi yapılır ve vardiya değişim saatlerinde otomatik raporlar oluşturulur.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Sistem, bordro yazılımları ile entegre çalışarak, ücret hesaplamalarında kullanılır. Fabrika ve sanayi tesislerinde üretim verimliliği analizi için de kullanılabilir. Departman bazlı raporlar, kişi bazlı detaylı kayıtlar ve özet raporlar alınabilir. Mobil uygulama üzerinden yöneticiler anlık personel durumunu görebilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Ziyaretçi Yönetim Sistemi</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Geçiş kontrol sistemleri, ziyaretçi yönetimi için de kullanılır. Ziyaretçiler için geçici kartlar veya PIN kodları oluşturulur. Ziyaretçinin giriş saati, çıkış saati, ziyaret edilen kişi ve ziyaret amacı kaydedilir. Ziyaretçi kartları, belirli alanlara ve belirli zaman dilimlerine sınırlandırılabilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Resepsiyon yazılımı ile entegre çalışarak, ziyaretçi kaydı hızlı ve kolay yapılır. Ziyaretçi fotoğrafı çekilir ve kimlik bilgileri kaydedilir. Ziyaret süresi dolduğunda sistem uyarı verir. Fabrika ve sanayi tesislerinde güvenlik için kritik öneme sahiptir. Tüm ziyaretçi hareketleri raporlanabilir ve denetlenebilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Entegrasyonlar ve Ek Özellikler</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Geçiş kontrol sistemleri, diğer güvenlik sistemleri ile entegre çalışır. IP kamera sistemleri ile entegrasyon sayesinde, her geçişte fotoğraf çekilir ve kayıt altına alınır. Hırsız alarm sistemleri ile entegrasyon ile, alarm devredeyken yetkisiz geçiş girişiminde alarm tetiklenir. Yangın alarm sistemleri ile entegrasyon ile, yangın durumunda tüm kapılar otomatik olarak açılır.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Asansör kontrol entegrasyonu ile, personel sadece yetkili olduğu katlara gidebilir. Otopark bariyer sistemleri ile entegrasyon ile, araç giriş-çıkışları da kontrol edilir. Yemekhane sistemi ile entegrasyon ile, yemek kartı olarak da kullanılabilir. Tüm bu entegrasyonlar, tek bir kart veya biyometrik kimlik ile yönetilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bakım ve Destek Hizmetleri</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Geçiş kontrol sistemleri kurulumu sonrasında düzenli bakım ve destek hizmeti sunuyoruz. Kart okuyucular temizlenir, biyometrik sensörler kalibre edilir, elektrikli kilitler test edilir. Yazılım güncellemeleri yapılır, veritabanı yedeklenir ve sistem optimizasyonu gerçekleştirilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Arızalı okuyucu değişimi, kilit tamiri, kart basımı ve personel ekleme/çıkarma hizmetleri de sunuyoruz. 7/24 teknik destek hattımız ile her türlü sorun anında çözülür. İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Tuzla, Gebze, Kocaeli, Bursa ve diğer bölgelerde hızlı servis hizmeti veriyoruz. Tüm kurulumlarımız 2 yıl garanti kapsamındadır.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-white text-center mb-12">
              Sıkça Sorulan Sorular
            </h2>

            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden hover:border-cyan-500/50 transition-all duration-300">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-xl font-bold text-white pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-2xl text-cyan-400 group-open:rotate-180 transition-transform duration-300"></i>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-white text-center mb-12">
              Diğer Güvenlik Sistemleri Hizmetlerimiz
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link to="/guvenlik-sistemleri/bariyer-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-slate-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-roadster-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-slate-400 transition-colors">Bariyer Sistemleri</h3>
                <p className="text-gray-400 text-sm">Otomatik bariyer kurulumu ve bakımı</p>
              </Link>

              <Link to="/guvenlik-sistemleri/turnike-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-gray-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-login-box-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-gray-400 transition-colors">Turnike Sistemleri</h3>
                <p className="text-gray-400 text-sm">Tripod ve kanatlı turnike sistemleri</p>
              </Link>

              <Link to="/guvenlik-sistemleri/ip-kamera-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-camera-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">IP Kamera Sistemleri</h3>
                <p className="text-gray-400 text-sm">4K Ultra HD kamera kurulumu</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-cyan-600/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Geçiş Kontrol Sistemi Kurulumu İçin Hemen İletişime Geçin
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Ücretsiz keşif ve teknik danışmanlık için bizi arayın. Profesyonel ekibimiz size en uygun çözümü sunar.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                +90 553 716 55 61
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </div>
  );
}